import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Button from '$lib/components/ui/button/button.svelte';
import { X, Wallet, Receipt, TrendingUp, TrendingDown, Minus } from '$lib/icons';

var root_3 = $.from_html(`<p class="text-sm text-muted-foreground text-center py-8"> </p>`);
var root_5 = $.from_html(`<div class="rounded-lg border p-3 space-y-2"><div class="flex items-start justify-between gap-2"><span class="font-medium truncate min-w-0 flex-1"> </span> <span class="font-medium shrink-0 tabular-nums"> </span></div> <div><span class="text-xs px-2 py-0.5 rounded-full bg-slate-100 text-slate-600"> </span></div> <div class="flex items-center justify-between text-sm pt-1 border-t"><span class="flex items-center gap-1 text-muted-foreground" title="Spent"><!> <span class="font-medium text-foreground tabular-nums"> </span></span> <span class="flex items-center gap-1 text-muted-foreground" title="Owned"><!> <span class="font-medium text-foreground tabular-nums"> </span></span> <span title="Balance"><!> <span class="font-medium tabular-nums"> </span></span></div></div>`);
var root_1 = $.from_html(`<div class="fixed inset-0 z-50 bg-black/50 flex items-end justify-center sm:items-center sm:p-4" role="dialog" aria-modal="true" aria-labelledby="participant-expenses-title" tabindex="-1"><div class="bg-background w-full max-w-[520px] rounded-t-xl sm:rounded-xl shadow-lg max-h-[calc(100vh-2rem)] flex flex-col animate-in fade-in slide-in-from-bottom-4 sm:zoom-in-95"><div class="flex items-center justify-between p-4 border-b shrink-0"><h2 id="participant-expenses-title" class="text-lg font-semibold truncate min-w-0 flex-1 mr-2"> </h2> <!></div> <div class="overflow-y-auto flex-1 p-4 space-y-3"><!></div> <div class="p-4 border-t shrink-0"><!></div></div></div>`);

export default function ParticipantExpensesModal($$anchor, $$props) {
	$.push($$props, true);

	// Expenses where participant is payer or has a share
	const participantExpenses = $.derived(() => $$props.expenses.filter((e) => e.payerId === $$props.participant.id || e.shares.some((s) => s.participantId === $$props.participant.id && s.amount > 0)));

	function formatSplitMode(mode) {
		switch (mode) {
			case 'BY_NIGHT':
				return 'By Night';

			case 'BY_SHARE':
				return 'By Share';

			case 'EQUAL':
				return 'Equal';

			case 'FREE':
				return 'Free';

			default:
				return mode;
		}
	}

	function formatCurrency(amount) {
		return new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' }).format(amount);
	}

	function getExpenseRow(expense) {
		const spent = expense.payerId === $$props.participant.id ? expense.amount : 0;
		const owned = expense.shares.find((s) => s.participantId === $$props.participant.id)?.amount ?? 0;
		const balance = spent - owned;

		return { spent, owned, balance };
	}

	function balanceColorClass(balance) {
		if (balance > 0.005) return 'text-green-600';
		if (balance < -0.005) return 'text-red-600';

		return 'text-muted-foreground';
	}

	function handleBackdropClick(event) {
		if (event.target === event.currentTarget) {
			$$props.onClose();
		}
	}

	function handleKeydown(event) {
		if (!$$props.open) return;

		if (event.key === 'Escape') {
			$$props.onClose();
		}
	}

	var fragment = $.comment();

	$.event('keydown', $.window, handleKeydown);

	var node = $.first_child(fragment);

	{
		var consequent_3 = ($$anchor) => {
			var div = root_1();

			div.__click = handleBackdropClick;

			var div_1 = $.child(div);

			div_1.__click = (e) => e.stopPropagation();

			var div_2 = $.child(div_1);
			var h2 = $.child(div_2);
			var text = $.child(h2);

			$.reset(h2);

			var node_1 = $.sibling(h2, 2);

			Button(node_1, {
				variant: 'ghost',
				size: 'sm',

				get onclick() {
					return $$props.onClose;
				},

				class: 'min-h-[44px] min-w-[44px] shrink-0',
				'aria-label': 'Close',

				children: ($$anchor, $$slotProps) => {
					X($$anchor, { class: 'h-4 w-4' });
				},

				$$slots: { default: true }
			});

			$.reset(div_2);

			var div_3 = $.sibling(div_2, 2);
			var node_2 = $.child(div_3);

			{
				var consequent = ($$anchor) => {
					var p = root_3();
					var text_1 = $.child(p);

					$.reset(p);
					$.template_effect(() => $.set_text(text_1, `No expenses found for ${$$props.participant.name ?? ''}.`));
					$.append($$anchor, p);
				};

				var alternate_2 = ($$anchor) => {
					var fragment_2 = $.comment();
					var node_3 = $.first_child(fragment_2);

					$.each(node_3, 17, () => $.get(participantExpenses), (expense) => expense.id, ($$anchor, expense) => {
						const row = $.derived(() => getExpenseRow($.get(expense)));
						var div_4 = root_5();
						var div_5 = $.child(div_4);
						var span = $.child(div_5);
						var text_2 = $.child(span, true);

						$.reset(span);

						var span_1 = $.sibling(span, 2);
						var text_3 = $.child(span_1, true);

						$.reset(span_1);
						$.reset(div_5);

						var div_6 = $.sibling(div_5, 2);
						var span_2 = $.child(div_6);
						var text_4 = $.child(span_2, true);

						$.reset(span_2);
						$.reset(div_6);

						var div_7 = $.sibling(div_6, 2);
						var span_3 = $.child(div_7);
						var node_4 = $.child(span_3);

						Wallet(node_4, { class: 'h-3.5 w-3.5 shrink-0' });

						var span_4 = $.sibling(node_4, 2);
						var text_5 = $.child(span_4, true);

						$.reset(span_4);
						$.reset(span_3);

						var span_5 = $.sibling(span_3, 2);
						var node_5 = $.child(span_5);

						Receipt(node_5, { class: 'h-3.5 w-3.5 shrink-0' });

						var span_6 = $.sibling(node_5, 2);
						var text_6 = $.child(span_6, true);

						$.reset(span_6);
						$.reset(span_5);

						var span_7 = $.sibling(span_5, 2);
						var node_6 = $.child(span_7);

						{
							var consequent_1 = ($$anchor) => {
								TrendingUp($$anchor, { class: 'h-3.5 w-3.5 shrink-0' });
							};

							var alternate_1 = ($$anchor) => {
								var fragment_4 = $.comment();
								var node_7 = $.first_child(fragment_4);

								{
									var consequent_2 = ($$anchor) => {
										TrendingDown($$anchor, { class: 'h-3.5 w-3.5 shrink-0' });
									};

									var alternate = ($$anchor) => {
										Minus($$anchor, { class: 'h-3.5 w-3.5 shrink-0' });
									};

									$.if(
										node_7,
										($$render) => {
											if ($.get(row).balance < -0.005) $$render(consequent_2); else $$render(alternate, false);
										},
										true
									);
								}

								$.append($$anchor, fragment_4);
							};

							$.if(node_6, ($$render) => {
								if ($.get(row).balance > 0.005) $$render(consequent_1); else $$render(alternate_1, false);
							});
						}

						var span_8 = $.sibling(node_6, 2);
						var text_7 = $.child(span_8, true);

						$.reset(span_8);
						$.reset(span_7);
						$.reset(div_7);
						$.reset(div_4);

						$.template_effect(
							($0, $1, $2, $3, $4, $5) => {
								$.set_text(text_2, $.get(expense).description);
								$.set_text(text_3, $0);
								$.set_text(text_4, $1);
								$.set_text(text_5, $2);
								$.set_text(text_6, $3);
								$.set_class(span_7, 1, `flex items-center gap-1 ${$4 ?? ''}`);
								$.set_text(text_7, $5);
							},
							[
								() => formatCurrency($.get(expense).amount),
								() => formatSplitMode($.get(expense).splitMode),
								() => formatCurrency($.get(row).spent),
								() => formatCurrency($.get(row).owned),
								() => balanceColorClass($.get(row).balance),
								() => formatCurrency(Math.abs($.get(row).balance))
							]
						);

						$.append($$anchor, div_4);
					});

					$.append($$anchor, fragment_2);
				};

				$.if(node_2, ($$render) => {
					if ($.get(participantExpenses).length === 0) $$render(consequent); else $$render(alternate_2, false);
				});
			}

			$.reset(div_3);

			var div_8 = $.sibling(div_3, 2);
			var node_8 = $.child(div_8);

			Button(node_8, {
				get onclick() {
					return $$props.onClose;
				},

				class: 'w-full min-h-[44px]',

				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_8 = $.text('Close');

					$.append($$anchor, text_8);
				},

				$$slots: { default: true }
			});

			$.reset(div_8);
			$.reset(div_1);
			$.reset(div);
			$.template_effect(() => $.set_text(text, `${$$props.participant.name ?? ''}'s Expenses`));
			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if ($$props.open) $$render(consequent_3);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

$.delegate(['click']);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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